import type { RundotGameAPI } from '../rundot-game-api/types'
import type {
  PlayableApi,
  PlayableCtaOptions,
  PlayableCtaResult,
  PlayableOutcome,
  PreSaveHook,
} from './PlayableApi'

export class MockPlayableApi implements PlayableApi {
  private readonly rundotGameApi: RundotGameAPI
  private readonly preSaveHooks = new Set<PreSaveHook>()
  private _isPlayableMock: boolean = false

  constructor(rundotGameApi: RundotGameAPI) {
    this.rundotGameApi = rundotGameApi
  }

  setPlayableMock(value: boolean): void {
    this._isPlayableMock = value
  }

  isPlayable(): boolean {
    const env = this.rundotGameApi._environmentData
    if (env?.executionMode === 'playable' || env?.capabilities?.cta === true) {
      return true
    }
    return this._isPlayableMock
  }

  async cta(options?: PlayableCtaOptions): Promise<PlayableCtaResult> {
    console.info('[RUN:mock] Playable CTA triggered:', options)
    return { completed: true }
  }

  async complete(outcome?: PlayableOutcome): Promise<void> {
    console.info('[RUN:mock] Playable complete triggered:', outcome)
  }

  milestone(name: string, params?: Record<string, unknown>): void {
    console.info(`[RUN:mock] Playable milestone "${name}":`, params)
  }

  onPreSave(hook: PreSaveHook): () => void {
    this.preSaveHooks.add(hook)
    return () => {
      this.preSaveHooks.delete(hook)
    }
  }

  /** Helper for tests to simulate pre-save flush */
  async triggerPreSaveAsync(): Promise<void> {
    for (const hook of this.preSaveHooks) {
      await hook()
    }
  }
}
